import { HiMoon, HiSun } from 'react-icons/hi2';
import { useTheme } from './ThemeProvider';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className="inline-flex shrink-0 items-center justify-center border-0 bg-transparent p-1 text-ink transition-colors hover:text-umber"
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      {isDark ? <HiSun className="size-5" aria-hidden="true" /> : <HiMoon className="size-5" aria-hidden="true" />}
    </button>
  );
}
